'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $(function () {
        $('[data-scroll-pane]', this).mCustomScrollbar({
            advanced: {
                updateOnContentResize: true
            },
            scrollButtons: {
                enable: false
            },
            scrollEasing: 'linear',
            scrollInertia: 150,
            mouseWheelPixels: "100"
        });
        $("#ean-filter", this).keypress(function (event) {
            if (event.which == 13) {
                $("#ean-filter-button").click();
            }
        });
    });

    var radioName = 'skFilter';
    var flagFilter = document.querySelector('.filter-flag-standalone');
    if (flagFilter && !flagFilter.flagFilterRegistered) {
        flagFilterLoad();
        flagFilter.addEventListener('click', function (e) {
            return flagFilterClick(e, true);
        });
        flagFilter.flagFilterRegistered = true;
    }

    function getSkFilterValue() {
        return flagFilter.querySelector('input[type=\'radio\'][name=\'' + radioName + '\']:checked').value;
    }

    function flagFilterLoad() {
        try {
            var selectedValue = getSkFilterValue();
            var flagInnerElement = flagFilter.querySelector('.flag-standalone');
            var clsList = flagInnerElement.classList;

            if (selectedValue === 'disabled') {
                clsList.add('filter-disabled');
                clsList.remove('filter-with');
                clsList.remove('filter-without');
                flagFilter.title = Resx.Common.FilterNotApply;
            } else if (selectedValue === 'onlysk') {
                clsList.remove('filter-disabled');
                clsList.add('filter-with');
                clsList.remove('filter-without');
                flagFilter.title = Resx.App.OnlySlovakianTitles;
            } else if (selectedValue === 'exceptsk') {
                clsList.remove('filter-disabled');
                clsList.add('filter-without');
                clsList.remove('filter-disabled');
                flagFilter.title = Resx.App.ExceptSlovakTitles;
            }
        } catch (e) {
            console.error('Error in flagFilterLoad method, productSearch module. ', e);
        }
    }

    function getRadioButtonToClick() {
        switch (getSkFilterValue()) {
            case 'disabled':
                return 'onlysk';
            case 'onlysk':
                return 'exceptsk';
            case 'exceptsk':
                return 'disabled';
        }
    }

    function flagFilterClick(event) {
        try {
            if (event && (event.target.tagName === 'INPUT' || event.target.tagName === 'RADIO')) {
                event.stopPropagation();
                return;
            }
            var nextState = getRadioButtonToClick();
            var radioButton = flagFilter.querySelector('input[type=\'radio\'][name=\'' + radioName + '\'][value=\'' + nextState + '\']');
            radioButton.click();
        } catch (e) {
            console.error('Error in flagFilterClick method, productSearch module. ', e);
        }
    }
};

var $ = require("jquery");

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/productSearch.js
// module id = 938
// module chunks = 0